import React, { useState } from "react";
import "./Step3Aadhaar.css";

function Step3Aadhaar({
  onNext,
  onBack,
  nextStep,
  prevStep,
  formData = {},
  updateFormData,
}) {
  // ==========================================================
  // DOCUMENT STATES
  // ==========================================================

  

  const [passportFile, setPassportFile] = useState(
    formData.passportFile || null
  );


  // ==========================================================
  // ERRORS
  // ==========================================================

  const [errors, setErrors] = useState({});

  // ==========================================================
  // FILE SETTINGS
  // ==========================================================

  const MAX_FILE_SIZE = 5 * 1024 * 1024;

  const ALLOWED_TYPES = [
    "image/jpeg",
    "image/png",
    "application/pdf",
  ];

  // ==========================================================
  // VALIDATE FILE
  // ==========================================================

  const validateFile = (file) => {
    if (!file) {
      return "Please select a file.";
    }

    if (!ALLOWED_TYPES.includes(file.type)) {
      return "Only JPG, PNG and PDF files are allowed.";
    }

    if (file.size > MAX_FILE_SIZE) {
      return "File size must be less than 5 MB.";
    }

    return "";
  };

  // ==========================================================
  // AADHAAR FILE
  // ==========================================================

  

  // ==========================================================
  // PASSPORT PHOTO
  // ==========================================================

  const handlePassportChange = (event) => {
    const file = event.target.files?.[0];

    if (!file) {
      setPassportFile(null);
      return;
    }

    const error = validateFile(file);

    if (error) {
      setErrors((previous) => ({
        ...previous,
        passport: error,
      }));

      setPassportFile(null);
      event.target.value = "";

      return;
    }

    setPassportFile(file);

    setErrors((previous) => ({
      ...previous,
      passport: "",
    }));
  };

  // ==========================================================
  // COMMUNITY CERTIFICATE
  // ==========================================================



  // ==========================================================
  // NEXT
  // ==========================================================

  const handleNext = (event) => {
    event.preventDefault();

    const newErrors = {};

    // --------------------------------------------------------
    // AADHAAR
    // --------------------------------------------------------

   

    // --------------------------------------------------------
    // PASSPORT PHOTO
    // --------------------------------------------------------

    if (!passportFile) {
      newErrors.passport =
        "Please upload Passport Size Photo.";
    }

    // --------------------------------------------------------
    // COMMUNITY CERTIFICATE
    // --------------------------------------------------------


    // --------------------------------------------------------
    // SHOW ERRORS
    // --------------------------------------------------------

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    // ========================================================
    // DOCUMENT DATA
    // ========================================================

    const documentData = {
     
      passportFile,

      // File names for Review Application
      
      passportFileName: passportFile.name,
      

      // Compatibility fields
    

      passport: passportFile.name,
      photo: passportFile.name,
      photoFile: passportFile.name,

      
    };

    // ========================================================
    // UPDATE PARENT DATA
    // ========================================================

    if (typeof updateFormData === "function") {
      updateFormData(documentData);
    }

    // ========================================================
    // SAVE ONLY FILE INFORMATION TO LOCAL STORAGE
    // ========================================================

    try {
      const existingData = JSON.parse(
        localStorage.getItem("registrationData") || "{}"
      );

      localStorage.setItem(
        "registrationData",
        JSON.stringify({
          ...existingData,



          passportFileName: passportFile.name,
          passportFileSize: passportFile.size,
          passportFileType: passportFile.type,

          
        })
      );
    } catch (error) {
      console.error(
        "Unable to save document information:",
        error
      );
    }

    // ========================================================
    // GO TO STEP 4
    // ========================================================

    if (typeof nextStep === "function") {
      nextStep(documentData);
      return;
    }

    if (typeof onNext === "function") {
      onNext(documentData);
    }
  };

  // ==========================================================
  // BACK
  // ==========================================================

  const handleBack = () => {
    if (typeof prevStep === "function") {
      prevStep();
      return;
    }

    if (typeof onBack === "function") {
      onBack();
    }
  };

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <div className="step3-page">

      <div className="step3-card">

        <form onSubmit={handleNext}>

          {/* ==================================================
              AADHAAR
          ================================================== */}

          


          {/* ==================================================
              PASSPORT PHOTO
          ================================================== */}

          <div className="step3-field">

            <label>
              Passport Size Photo
              <span>*</span>
            </label>

            <input
              type="file"
              accept=".jpg,.jpeg,.png,.pdf"
              onChange={handlePassportChange}
            />

            {errors.passport && (
              <div className="step3-error">
                {errors.passport}
              </div>
            )}

          </div>


          {/* ==================================================
              COMMUNITY CERTIFICATE
          ================================================== */}



          {/* ==================================================
              INFORMATION
          ================================================== */}

          <div className="step3-info-box">

            <div className="step3-info-icon">
              i
            </div>

            <div>
              <strong>
                Allowed formats: JPG, PNG, PDF
              </strong>

              <br />

              <span>
                Max file size: 5MB each
              </span>
            </div>

          </div>


          {/* ==================================================
              BUTTONS
          ================================================== */}

          <div className="step3-actions">

            <button
              type="button"
              className="step3-back-button"
              onClick={handleBack}
            >
              BACK
            </button>

            <button
              type="submit"
              className="step3-next-button"
            >
              NEXT
            </button>

          </div>

        </form>

      </div>

    </div>
  );
}

export default Step3Aadhaar;